<mat-card *authGroup="['SuperAdmin']" class="ui-wrapper">
<mat-card-title>Users</mat-card-title>

  <div class="row mb-3 align-items-start g-2">
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search users</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Name, email or phone"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Company or individual</mat-label>
        <input
          matInput
          [formControl]="practiceSearchControl"
          placeholder="Company or individual (vet) name"
        />
        <mat-icon matSuffix>business</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Account status</mat-label>
        <mat-select [formControl]="enabledFilter">
          <mat-option value="enabled_only">Enabled</mat-option>
          <mat-option value="all">All</mat-option>
          <mat-option value="disabled">Disabled</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

<table mat-table [dataSource]="usersDataSource" class="user-list">

    <ng-container matColumnDef="name">
        <th class="px-2"  mat-header-cell *matHeaderCellDef>Name</th>
        <td class="px-2" mat-cell *matCellDef="let user"> {{getAttribute('name', user)}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th class="px-2" mat-header-cell *matHeaderCellDef> Email </th>
        <td class="px-2"  mat-cell *matCellDef="let user"> {{getAttribute('email', user)}} </td>
    </ng-container>

    <ng-container matColumnDef="phone_number">
        <th class="px-2" mat-header-cell *matHeaderCellDef>Phone number</th>
        <td class="px-2" mat-cell *matCellDef="let user"> {{getAttribute('phone_number', user)}} </td>
    </ng-container>

    <ng-container matColumnDef="company_or_individual">
        <th class="px-2" mat-header-cell *matHeaderCellDef>Company / Individual</th>
        <td class="px-2" mat-cell *matCellDef="let user">
          {{ getCompanyOrIndividualLabel(user) || '-' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th class="px-2" mat-header-cell *matHeaderCellDef>Status</th>
        <td class="px-2" mat-cell *matCellDef="let user"> 
            {{ normalizeText(user.UserStatus) || '-' }}
        </td>
    </ng-container>
    
    <ng-container matColumnDef="enabled">
        <th class="px-2" mat-header-cell *matHeaderCellDef>Enabled</th>
        <td class="px-2" mat-cell *matCellDef="let user"> 
            <mat-icon [ngClass]="{'greyed': !isUserEnabled(user)}">done</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th class="px-2" mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td class="px-2" mat-cell *matCellDef="let user"> 
            <button mat-stroked-button *ngIf="isUserEnabled(user)" (click)="disableUser($event,user)">
                Disable
            </button>
            <button mat-stroked-button *ngIf="!isUserEnabled(user)" (click)="enableUser($event,user)">
                Enable 
            </button>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row (click)="viewUser(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div class="row mt-2">
        <p class="col-md-3">
            <mat-form-field appearance="outline">
                <mat-label>Per page</mat-label>
                <mat-select [formControl]="perPageControl">
                    <mat-option value="10">10</mat-option>
                    <mat-option value="15">15</mat-option>
                    <mat-option value="20">20</mat-option>
                </mat-select>
            </mat-form-field>
        </p>
        <p class="col-md-9 text-end">
            <button *ngIf="page > 1" [disabled]="loading" (click)="lastPage()" mat-stroked-button color="primary">
                Prev
            </button>
            <button *ngIf="nextToken" [disabled]="loading" (click)="nextPage()" mat-stroked-button color="primary">
                Next
            </button>
        </p>
</div>
</mat-card>
